import 'react-app-polyfill/ie11';
import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);